import { COLORS } from '@btime/constants'
import { concatIf } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { Title } from '../../../components/presentation/Text'
import { useOpenTriggersModal } from '../../../utils/routes/modals/modalsActions'
import DropdownLink from '../../../components/navigation/DropdownLink'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import IconText from '../../../components/presentation/IconText'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const { t } = useTranslation(['common', 'listForms'])

  const openTriggersModal = useOpenTriggersModal()

  const options = [
    ...concatIf(true, [
      {
        value: 'triggers',
        iconLeft: 'RiRobotLine',
        onClick: () => openTriggersModal({ entities: ['form_reply', 'form'] })
      },

      {
        value: 'integrations',
        iconLeft: 'RiPlugLine',
        onClick: () => openTriggersModal({ entities: ['form_reply', 'form'], integrationsOnly: true })
      },

      { line: true }
    ])
  ]

  return (
    <Fragment>
      <Separator weight={12} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol>
          <Title size="h2" color={COLORS.dark3} noWrap>
            {t('listForms:title')}
          </Title>
        </FlexCol>

        <FlexCol flex={1}></FlexCol>

        {!!options.length && (
          <FlexCol>
            <DropdownLink
              fromRight
              t={key => t(`listForms:menu.${key}`)}
              options={options}
              actionContent={
                <IconText label={t('moreOptions')} iconName="BsThreeDotsVertical" noWrap size="small" bold />
              }
            />
          </FlexCol>
        )}
      </FlexGrid>
      <Separator weight={2} />
    </Fragment>
  )
}

export default PageHeader
